import React from "react";
import DocumentSigner from "../common/DocumentSigner";
import { CPILetterProps } from "./CpiLetterTypes";

const CPILetter = (props: CPILetterProps) => {
  const { getLetterDetails } = props;
  const targetFolderNames = ["consent for personal identity information"];

  return (
    <DocumentSigner
      getLetterDetails={getLetterDetails}
      targetFolderNames={targetFolderNames}
    />
  );
};

export default CPILetter;
